import styles from './contactboxblock.css'

type ContactBoxBlockProps = {
  value: {
    heading: string
    text: string
    name: string
    email: string
  }
}

const ContactBoxBlock = ({ value: { heading, text, name, email } }: ContactBoxBlockProps): JSX.Element => (
  <div className={styles.container}>
    <p className={styles.heading}>{heading}</p>
    <span className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
    <section>
      <div className={styles.avatar} />
      <div>
        <span className={styles.name}>{name}</span>
        <a className={styles.email} href={`mailto:${email}`}>
          {email}
        </a>
      </div>
    </section>
  </div>
)

export default ContactBoxBlock
